<template>
    <span style="white-space: nowrap">
        {{ params.valueFormatted || params.value }}
        &nbsp;
        <span v-if="isNotSettled && daysOverdue > 0" class="invalid_color">({{ daysOverdue }})</span>
    </span>
</template>

<script>

import {enumDef} from "@/common/enumDefs";

export default {
    computed: {
        isNotSettled() {
        	let auctionStatus = this.params.data[this.params.auctionStatusField];
        	if (auctionStatus !== enumDef.auctionStatus.Sold) {
        		return false;
			}

        	if (this.params.paymentStatusField) {
		        let paymentStatus = this.params.data[this.params.paymentStatusField];
		        return !enumDef.paymentStatus.isSettled(paymentStatus);
			} else if (this.params.receivableStatusField) {
		        let receivableStatus = this.params.data[this.params.receivableStatus];
        		return receivableStatus === enumDef.receivableStatus.InSettlement || receivableStatus === enumDef.receivableStatus.Contested;
			}

	        console.error("Status field for overdue condition is not set.");
        	return false;
        },
        daysOverdue() {
            let target = moment(this.params.value).format("YYYY-MM-DD");
            let today = moment().format("YYYY-MM-DD");

            return moment(today).diff(target, "d");
        }
    }
};
</script>